
import { useEffect } from "react";
import { Profile } from "./pages/profile/profile";
import { SignIn } from "./pages/signIn/signin";
import { HashRouter as Router, useRoutes } from "react-router-dom";
import Cookies from "universal-cookie";

function App() {
  const cookies = new Cookies();
  const token = cookies.get('token');
  useEffect(() => {
    document.title = "GraphQL"
  })



  let element = token ? <Profile /> : <SignIn />;
  let routes = useRoutes([
    { path: '/', element: <SignIn /> },
    { path: '/profile', element: element },
  ]);

  return routes
}

const AppWrapper = () => {
  return (
    <Router basename={"/"}>
      <App />
    </Router>
  );
};

export default AppWrapper;